import { CSSProperties } from 'react'
import Styles from './DesignLoadingPreview.module.scss'
import { LoadingShimmerer } from 'components/LoadingShimmerer/LoadingShimmerer'

export const DesignLoadingPreview = ({ width, height }: { width: number; height: number }) => {
  return (
    <div className={Styles.designLoadingPreview}>
      <LoadingShimmerer
        className={Styles.loading}
        borderRadius="20px 20px 20px 20px"
        style={
          {
            '--aspect-ratio': `${width} / ${height}`,
          } as CSSProperties
        }
      />
    </div>
  )
}
